import debounce from 'lodash.debounce'
import { useEffect, useMemo, useRef } from 'react'

export const useDebounce = (callback) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = callback
  }, [callback])

  return useMemo(() => {
    const func = () => {
      ref.current?.()
    }

    return debounce(func, 1000)
  }, [])
}
